import React from "react";
import { Controller } from "react-hook-form";

const EnginesCheckboxList = ({ generationId, control, engines }) => {
  return (
    <div style={styles.wrapper}>
      <Controller
        name={`engine_generation_${generationId}`}
        control={control}
        defaultValue={[]}
        render={({ field }) => {
          const selectedIds = field.value || [];

          const toggleEngine = (id) => {
            if (selectedIds.includes(id)) {
              field.onChange(selectedIds.filter((eId) => eId !== id));
            } else {
              field.onChange([...selectedIds, id]);
            }
          };

          return engines.map((engine) => {
            const engineId = engine.id_car_motor;
            return (
              <label key={engineId} style={styles.label}>
                <input
                  type="checkbox"
                  checked={selectedIds.includes(engineId)}
                  onChange={() => toggleEngine(engineId)}
                  style={styles.checkbox}
                />
                {engine.name || engine.label}
              </label>
            );
          });
        }}
      />
    </div>
  );
};

export default EnginesCheckboxList;

const styles = {
  wrapper: {
    marginLeft: 36,
    marginTop: 8,
  },
  label: {
    display: "block",
    marginBottom: 5,
    cursor: "pointer",
  },
  checkbox: {
    marginRight: 8,
  },
};
